import { render, staticRenderFns } from "./ShareList.vue?vue&type=template&id=22ed1531&scoped=true"
import script from "./ShareList.vue?vue&type=script&lang=js"
export * from "./ShareList.vue?vue&type=script&lang=js"
import style0 from "./ShareList.vue?vue&type=style&index=0&id=22ed1531&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ed1531",
  null
  
)

export default component.exports